import React from "react";

import ThemeMenu from "@/components/ThemeMenu/ThemeMenu";
import DropDown from "@/shared/components/DropDown/DropDown";
import ThemeButton from "@/shared/components/Button/ThemeButton";

import {
  isDarkTheme,
  MapIdThemeDarkToIdThemeLight, MapIdThemeLightToIdThemeDark,
} from "@/shared/utils/theme/theme";
import { usePagePropsContext } from "@/contexts/pageProps";
import { useTheme } from "@/hooks/useTheme";

const ButtonTheme = ({ className, classNameButton, onClick }) => {
  const { isLanding, landingBookViewConfig } = usePagePropsContext();
  const { activeTheme, updateTheme } = useTheme();

  const toggleLightDarkTheme = () => {
    const idThemeDefault = landingBookViewConfig?.defaultTheme;
    const isThemeDefaultDark = isDarkTheme(idThemeDefault);

    let idThemeLight, idThemeDark;

    if (isThemeDefaultDark) {
      idThemeLight = MapIdThemeDarkToIdThemeLight[idThemeDefault];
      idThemeDark = idThemeDefault;
    } else {
      idThemeLight = idThemeDefault;
      idThemeDark = MapIdThemeLightToIdThemeDark[idThemeDefault];
    }

    const idThemeNew = activeTheme === idThemeLight ? idThemeDark : idThemeLight;

    updateTheme(idThemeNew);
  };

  const renderBtn = (active, openDD) => {
    const handleClick = (e) => {
      if (onClick) {
        onClick(e);
      }

      if (isLanding) {
        toggleLightDarkTheme();
      } else {
        if (openDD) {
          openDD(e);
        }
      }
    };

    const isDark = isDarkTheme(activeTheme);

    return (
      <ThemeButton
        isLightDarkModesOnly
        active={active}
        className={classNameButton}
        isDarkTheme={isDark}
        onClick={handleClick}
      />
    );
  };

  if (isLanding) {
    return renderBtn();
  }

  return (
    <DropDown
      className={className}
      toggleOnClickButton
      button={({ show, onClick }) => renderBtn(show, onClick)}
      popupProps={{
        hideOnScroll: false,
        // So the user will see what colors of a new chosen theme.
        backdropProps: {
          style: {
            backgroundColor: "transparent",
          },
        },
        // ========================================================
      }}
      body={<ThemeMenu />}
    />
  );
};

export default ButtonTheme;
